/* eslint-disable camelcase */
'use strict';

module.exports = {
  da: require('./da_DK'),
  de: require('./de_DE'),
  en: require('./en_US'),
  en_AU: require('./en_AU'),
  en_GB: require('./en_GB'),
  es: require('./es_ES'),
  fr_CA: require('./fr_CA'),
  fr: require('./fr_FR'),
  id: require('./id_ID'),
  it: require('./it_IT'),
  ja: require('./ja_JP'),
  ko: require('./ko_KR'),
  nl: require('./nl_NL'),
  no: require('./no_NO'),
  pl: require('./pl_PL'),
  pt_BR: require('./pt_BR'),
  pt: require('./pt_PT'),
  ru: require('./ru_RU'),
  sv: require('./sv_SE'),
  th: require('./th_TH'),
  zh: require('./zh_CN'),
  zh_HK: require('./zh_HK'),
  zh_TW: require('./zh_TW')
};
/* eslint-enable camelcase */



//////////////////
// WEBPACK FOOTER
// ./~/braintree-web-drop-in/translations/index.js
// module id = 831
// module chunks = 0